export enum ACTIONS {
    SET_USER = "setUser",
    SET_LOADING = "setLoading",
    SET_BUTTON = "setButton",
    SET_RELOAD= "setReload",
  }